import { JobPosition } from '__gql-generated__/types'
import type { LanguageTokens } from 'i18n'

export enum Roles {
  BASIC = 'Básico',
  ADVANCED = 'Avançado',
  ADMIN = 'Admin'
}

export const roles = [Roles.BASIC, Roles.ADVANCED, Roles.ADMIN]

export const ROLES_BY_JOB_POSITION = {
  admin: [
    JobPosition.Administrative,
    JobPosition.Financial,
    JobPosition.It,
    JobPosition.EducationalTechnology,
    JobPosition.Coordinator,
    JobPosition.Principal
  ],
  advanced: [
    JobPosition.Teacher,
    JobPosition.Librarian,
    JobPosition.PedagogicalAdvisor,
    JobPosition.Psychologist,
    JobPosition.AssistantOrIntern
  ]
}

export const JOB_POSITIONS_OPTIONS: {
  label: LanguageTokens
  value: JobPosition | 'GENERAL_SERVICES'
}[] = [
  {
    label: 'Professor(a)',
    value: JobPosition.Teacher
  },
  {
    label: 'Administrativo',
    value: JobPosition.Administrative
  },
  {
    label: 'Diretor(a)',
    value: JobPosition.Principal
  },
  {
    label: 'Assistente ou Estagiário(a)',
    value: JobPosition.AssistantOrIntern
  },
  {
    label: 'Financeiro(a)',
    value: JobPosition.Financial
  },
  {
    label: 'Bibliotecário(a)',
    value: JobPosition.Librarian
  },
  {
    label: 'Tecnologia Educacional',
    value: JobPosition.EducationalTechnology
  },
  {
    label: 'Serviços Gerais',
    value: JobPosition.SchoolSupport
  },
  {
    label: 'Orientador(a) Pedagógico',
    value: JobPosition.PedagogicalAdvisor
  },
  {
    label: 'TI',
    value: JobPosition.It
  },
  {
    label: 'Psicólogo(a)',
    value: JobPosition.Psychologist
  },
  {
    label: 'Coordenador(a)',
    value: JobPosition.Coordinator
  }
]

export const ROLES_TOPICS: Record<Roles, LanguageTokens[]> = {
  Básico: ['Pode sugerir leituras para os usuários'],
  Avançado: [
    'Cria, aplica, corrige e cancela atividades',
    'Aplica e corrige avaliações',
    'Cria e edita metas de leitura',
    'Acompanha dados de progresso através de relatórios'
  ],
  Admin: [
    'Cadastra e edita usuários, turmas, unidades ou redes',
    'Ativa ou desativa conteúdos',
    'Gerencia permissões de usuários'
  ]
}
